import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import './App.css';
import { GuessRow } from './components/guess-row';

function App() {
  return (
    <div className="App">
      <header className="app-header">
        <h1 className="app-title">Kirtdle</h1>
      </header>
      <GuessRow />
      <ToastContainer limit={3} />
    </div>
  );
}

export default App;
